import { type HeapAttributesType } from './heapAttributes'

export const createHeapDataAttribute = (attribute: HeapAttributesType) => ({
  [`data-${attribute}`]: 'true',
})
